
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';

import SponsorBar from './components/SponsorBar';
import PartnerBar from './components/PartnerBar';
import PrivacyPolicy from './components/PrivacyPolicy'; // <--- Ide tedd be (vagy ahova mentetted a fájlt)

import './App.css';

function App() {
  useEffect(() => {
    // Globális nem kezelt Promise hibafigyelő
    window.addEventListener('unhandledrejection', function (event) {
      console.error('Nem kezelt Promise hiba:', event.reason);
    });

    return () => {
      window.removeEventListener('unhandledrejection', function () { });
    };
  }, []);

  return (
    <Router>
      <div className="app-container">
        {/* Felső támogatói sáv */}
        <SponsorBar />

        {/* Oldaltartalom */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/adatvedelmi-tajekoztato" element={<PrivacyPolicy />} /> {/* <--- Ez kell ide */}
          </Routes>
        </main>

        {/* Alsó partner sáv */}
        <PartnerBar />
      </div>
    </Router>

  );
}

export default App;
